import numeral from "numeral";
import React from "react";
import { CardMain } from "../../../components/card/CardMain";
import Container from "../../../components/layout/Container";
import { cn } from "../../../utils/useFunctions";
import {
  STYLE_MARGIN_TOP_PARENT,
  STYLE_PARENT_PADDING,
  STYLE_TEXT_BLUE,
} from "../../../utils/useStyle";
import PdfFooter from "../component/pdf.c.footer";
import PdfHeader from "../component/pdf.c.header";
import { PdfHeaderText } from "../component/pdf.c.headerText";
import PdfLine from "../component/pdf.c.line";
import { STYLE_PAGE } from "../styles/pdf.style";
import {
  Tax408PropertyPercent,
  tax405Percent,
} from "../../../functions/taxFucntion/premium/businessFunction";

const Income408property = ({
  page,
  taxData = {},
  datalist = [],
  isFirst = false,
  isLast = false,
}) => {
  return (
    <div className={cn(STYLE_PAGE)}>
      <PdfHeader />
      <PdfLine />
      <PdfHeaderText
        title="วางแผนภาษี"
        icon="/images/tax_plan.svg"
        classNameIcon="w-[24px] h-[27px]"
      />

      <Container classnameInner={""}>
        <div className={STYLE_MARGIN_TOP_PARENT}>
          <div className={STYLE_PARENT_PADDING}>
            {isFirst && (
              <CardMain
                border={false}
                icon={false}
                marginyellow="mt-0"
                padding=" py-0 "
                panel={
                  <div className=" px-3 -mt-3">
                    <div className="text-[12px] font-[500]">
                      เงินได้จากการขายอสังหาริมทรัพย์ฯ (มาตรา 40(8))
                    </div>
                  </div>
                }
              />
            )}
            {datalist?.map((item, index) => {
              return (
                <CardMain
                  border={false}
                  icon={false}
                  marginyellow="mt-3"
                  panel={
                    <div className=" px-3 -mt-3">
                      <div className="w-fit flex justify-between text-[11px] font-[500]">
                        <div
                          className={` text-base text-mainblue font-semibold w-full mb-1`}
                        >
                          รายการที่
                        </div>
                        <div
                          className={cn(STYLE_TEXT_BLUE, {
                            "w-fit whitespace-nowrap  text-base text-mainblue font-semibold": true,
                          })}
                        >
                          {item?.order}
                        </div>
                      </div>
                      <div className="w-full flex justify-between text-[11px] font-[500]">
                        <div className={`${STYLE_TEXT_BLUE} w-full mb-1`}>
                          ประเภทธุรกิจ
                        </div>
                        <div
                          className={cn(STYLE_TEXT_BLUE, {
                            "w-fit whitespace-nowrap": true,
                            " text-red-500": !item?.type_job?.label,
                          })}
                        >
                          {" "}
                          {`${
                            item?.type_job?.label ||
                            "กรุณาเลือกประเภทธุรกิจบนเว็บไซต์ที่แผนภาษี" ||
                            "-"
                          }`}{" "}
                        </div>
                      </div>
                      <div className="w-full flex justify-between text-[11px] font-[500]">
                        <div className={`${STYLE_TEXT_BLUE} w-full mb-1`}>
                          เงินได้ทั้งหมด
                        </div>
                        <div
                          className={cn(STYLE_TEXT_BLUE, {
                            "w-fit whitespace-nowrap": true,
                          })}
                        >
                          {" "}
                          {`${numeral(
                            item?.tax_income || item?.other_income_peryear
                          )?.format("0,0")} บาท`}{" "}
                        </div>
                      </div>
                      <div className="w-full flex justify-between text-[11px] font-[500]">
                        <div className={`${STYLE_TEXT_BLUE} w-full mb-1`}>
                          ภาษีหัก ณ ที่จ่าย
                        </div>
                        <div
                          className={cn(STYLE_TEXT_BLUE, {
                            "w-fit whitespace-nowrap": true,
                          })}
                        >
                          {" "}
                          {`${numeral(
                            item?.with_holding_tax || item?.tax_income_other
                          )?.format("0,0")} บาท`}{" "}
                        </div>
                      </div>
                      <div className="w-full flex justify-between text-[11px] font-[500]">
                        <div className={`${STYLE_TEXT_BLUE} w-full mb-1`}>
                          เลขผู้จ่ายเงินได้
                        </div>
                        <div
                          className={cn(STYLE_TEXT_BLUE, {
                            "w-fit whitespace-nowrap": true,
                          })}
                        >
                          {" "}
                          {`${item?.tax_payer_ID || "-"}`}{" "}
                        </div>
                      </div>
                      {item?.type_job?.label !==
                        "เงินส่วนแบ่งของกำไรจากกองทุนรวมตามประกาศคณะปฏิวัติฯ" && (
                        <div className="w-full flex justify-between text-[11px] font-[500]">
                          <div
                            className={`font-semibold text-black mt-2 text-sm`}
                          >
                            การคำนวณค่าใช้จ่าย
                          </div>
                        </div>
                      )}
                      {!item?.calculating_method && (
                        <div className="w-full flex justify-between text-[11px] font-[500]">
                          <div className={`text-red-500 w-full mb-1`}>
                            กรุณาตรวจสอบการหักค่าใช้จ่ายบนเว็บไซต์ที่แผนภาษี
                          </div>
                        </div>
                      )}
                      {item?.calculating_method &&
                        item?.calculating_method === "หักแบบเหมา" && (
                          <div className="w-full flex justify-between text-[11px] font-[500]">
                            <div className={`${STYLE_TEXT_BLUE} w-full mb-1`}>
                              {`${item?.calculating_method} ${
                                item?.type_job?.label ===
                                "การขายอสังหาริมทรัพย์ที่ได้มาโดยมิได้มุ่งในทางการค้าหรือหากำไร"
                                  ? Tax408PropertyPercent(
                                      item?.tax_holding_year || 0
                                    )
                                  : 50
                              }%`}
                            </div>
                            <div
                              className={cn(STYLE_TEXT_BLUE, {
                                "w-fit whitespace-nowrap": true,
                              })}
                            >
                              {" "}
                              {`${numeral(
                                item?.income_for_calculating_all_in
                              )?.format("0,0")} บาท`}{" "}
                            </div>
                          </div>
                        )}
                      {item?.calculating_method &&
                        item?.calculating_method !== "หักแบบเหมา" && (
                          <div className="w-full flex justify-between text-[11px] font-[500]">
                            <div className={`${STYLE_TEXT_BLUE} w-full mb-1`}>
                              {`${item?.calculating_method}`}
                            </div>
                            <div
                              className={cn(STYLE_TEXT_BLUE, {
                                "w-fit whitespace-nowrap": true,
                              })}
                            >
                              {" "}
                              {`${numeral(item?.Tax_Real)?.format(
                                "0,0"
                              )} บาท`}{" "}
                            </div>
                          </div>
                        )}
                    </div>
                  }
                />
              );
            })}
          </div>
        </div>
      </Container>
      <PdfFooter page={page} />
    </div>
  );
};

export default Income408property;
